import React, { useEffect, useState } from "react";
import allApi from "../../../../api/allApi";
import errorIcon from "../../../../assets/images/error-2.png";
import { useLocalization } from "../../localization/LocalizationContext";
import { isFlagOn } from "../../common/configValidation";

function FastRoaming({networkId}) {
  const {localizationStrings} = useLocalization();
  const [fastRoaming, setFastRoaming] = useState(null);
  const [showModal, setShowModal] = useState(false); 
  const [pendingStatus, setPendingStatus] = useState(null); 

  useEffect(()=>{
  getFastRoaming(networkId);
  },[networkId]);

  const getFastRoaming = async() =>{
    try{
     const api = new allApi();
     const result = await api.getRequest(`api/wireless/getFastRoaming?networkId=${networkId}`);
     const flag =
      result?.response?.fastRoaming ??
      result?.data?.fastRoaming ??
      result?.fastRoaming;
     if (flag !== undefined && flag !== null) {
      setFastRoaming(isFlagOn(flag));
     } else if (result && result.status === "OK") {
      setFastRoaming(true);
     } else {
      setFastRoaming(false);
     } 
    
    }catch(error){
      console.error("Error fetching fast roaming",error);
    }
  };

  const inputFastRoaming = async(status) =>{
    try{
     const api = new allApi();
     const payload = {
       fastRoaming: status,
     }
     const response = await api.postRequest(`api/wireless/fastRoaming?networkId=${networkId}`,"",payload);
     if(response){
      setFastRoaming(status);
     }
    }catch(error){
    console.error("Error in  enabling/disabling Fast Roaming",error);
    }
  };

  const handleEnableRoaming = () => {
    if (fastRoaming) {
      setPendingStatus(false);
      setShowModal(true);
    } else {
      inputFastRoaming(!fastRoaming);
    }
  };

  const handleModalConfirm = () => {
    setShowModal(false);
    if (pendingStatus !== null) {
      inputFastRoaming(pendingStatus);
      setPendingStatus(null);
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setPendingStatus(null);
  };

  return (
    <div className="tab-form mt-3">
      <p>{localizationStrings?.roamingInfo1} <br />{localizationStrings?.roamingInfo2} <i className="fa fa-angle-right" aria-hidden="true"></i> {localizationStrings?.roamingInfo3}</p>

      <div className="row mt-4">
        <div className="col-lg-4">
          <div className="switch-box">
            <strong>{localizationStrings?.enable}</strong>
            {fastRoaming !== null ? (
              <label className="ice-switch">
                <input
                  type="checkbox"
                  checked={fastRoaming}
                  onChange={handleEnableRoaming}
                />
                <span className="slider"></span>
              </label>
            ) : (
              <p>{localizationStrings?.loading}...</p> 
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <p>
                  {localizationStrings?.disableRoamingInfo}
                </p>
                <h3>{localizationStrings?.continueMsg}</h3>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline" onClick={handleModalCancel}>
                    {localizationStrings?.no}
                  </button>
                  <button className="text-btn primary-btn" onClick={handleModalConfirm}>
                    {localizationStrings?.yes}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FastRoaming;
